module.exports = __webpack_public_path__ + "img/django.39055eed.png";